module.exports = __webpack_public_path__ + "img/about-us-2.4c982c4c.jpg";